<template>
  <slot name="activator" :on="listeners" :attrs="attrs" :is-active="isActive"></slot>

  <Teleport v-if="rootElement" :to="rootElement">
    <transition name="fade">
      <div :class="[bemClass()]"
           v-show="isAlwaysActive || isActive"
           v-on="listeners"
           v-bind="$attrs"
      >
        <slot></slot>
      </div>
    </transition>
  </Teleport>
</template>

<script>
import hoverActivator from '../../compositions/hover-activator'
import { toRefs } from 'vue'
import useBem from '../../compositions/bem'

export default {
  name: 'SelMenu',
  inheritAttrs: false,
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    isAlwaysActive: {
      type: Boolean,
      default: false
    },
    rootElement: {
      type: [String, Object],
      default: '#menu-target'
    },
    activatorSelector: {
      type: String
    },
    modifier: {
      type: String,
      default: ''
    }
  },
  setup (props, { emit }) {
    const { modifier } = toRefs(props)
    const { bemClass } = useBem('sel-menu', modifier)

    return {
      bemClass,
      ...hoverActivator(props, { emit })
    }
  }
}
</script>
